import { useNavigate } from 'react-router-dom';

import { updateHealthcareProgramConfig } from 'api/HealthcareProgram';

import { HEALTHCARE_PROGRAM_QUERY_KEY } from 'lib/constants/healthcareProgram/eligibilitySetup';
import { useCustomMutation } from 'lib/hooks/useCustomMutation';

export const useUpdateHealthcareProgramConfig = ({ onSuccess, practiceId } = {}) => {
  const navigate = useNavigate();

  return useCustomMutation({
    mutationFn: (patch) =>
      updateHealthcareProgramConfig(navigate, {
        patch,
        ...(practiceId != null && { practice_id: practiceId })
      }),
    successMessage: 'Healthcare Program settings updated',
    invalidateQueryKey: HEALTHCARE_PROGRAM_QUERY_KEY,
    onSuccess
  });
};
